import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { DiallerPage } from '@/components/dialler/dialler-page';

// When a setter clicks "Call" on a contact card, we deep-link here with
// `contactId` (so DiallerPage can load that specific contact) and `autoDial`
// (so the call fires without the usual countdown). Both are optional —
// loading /dialler with no params shows the normal queue UI.
const diallerSearchSchema = z.object({
  contactId: z.string().uuid().optional(),
  autoDial: z.boolean().optional(),
});

export type DiallerSearch = z.infer<typeof diallerSearchSchema>;

export const Route = createFileRoute('/_auth/dialler')({
  component: DiallerPage,
  validateSearch: diallerSearchSchema,
});
